import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VisaDesignerService } from '../visa-designer.service';

@Component({
  selector: 'app-vd-generate-letters',
  templateUrl: './vd-generate-letters.component.html',
  styleUrls: ['./vd-generate-letters.component.scss']
})
export class VdGenerateLettersComponent implements OnInit {
  visaInfo: any;

  constructor(private router: Router, private route: ActivatedRoute, private vdService:VisaDesignerService) { }

  ngOnInit(): void {
    this.vdService.getVisaInfo.subscribe((response) => {
      console.log("letter generation",response);
      this.visaInfo = response;
     });
  }

  handleRoutePath(routePath,lettertype?){
    if(lettertype){
      this.router.navigate([`${routePath}`],{ queryParams: { type: lettertype },  relativeTo: this.route });
    }else{
      this.router.navigate([`${routePath}`], { relativeTo: this.route });
    }
      
  }

  handleNext(){
    this.router.navigate([`../review`], { queryParams: { id: this.visaInfo.visaId }, relativeTo: this.route });
  }
  handleGoback(){
    this.router.navigate([`../task-details`], { queryParams: { id: this.visaInfo.visaId }, relativeTo: this.route });
    
  }
}
